import { InjectionToken } from '@angular/core';
type PlasticStageGroup = {
  stageName: 'Inspeccion final' | 'Ensamble';
  nextStage: string;
  stageReport?: string;
};
export const PLASTIC_PART_STAGE_GROUP = new InjectionToken<PlasticStageGroup>(
  'Specification of part stage',
  {
    providedIn: 'root',
    factory: () => undefined,
  }
);
